import { actions, selectors } from 'data'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import WithdrawModal from './WithdrawModal'

const Withdraw = () => {
  const modalOptions = useSelector(selectors.app.getModalOptions)
  const dispatch = useDispatch()
  // track exit flow on unmount
  useEffect(() => {
    return () => {
      dispatch(
        actions.analytics.trackEvent({
          key: 'Withdrawal Flow Exited',
          properties: {}
        })
      )
    }
  }, [])
  return <WithdrawModal currency={modalOptions.currency} />
}

export default Withdraw
